"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RulesManager = void 0;

var _escapeStringRegexp = _interopRequireDefault(require("escape-string-regexp"));

var _defaultRules = require("./default-rules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var REGEX_RULES_EXTRACTOR = /\{(\w+),?([\w\:\-]+)?\}/g;

var RulesManager = /*#__PURE__*/function () {
  function RulesManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        rules = _ref.rules;

    _classCallCheck(this, RulesManager);

    this.rules = _objectSpread({}, _defaultRules.DefaultRules, {}, rules);
  }

  _createClass(RulesManager, [{
    key: "process",
    value: function process(str, args) {
      var _this = this;

      var replacements = RulesManager.findCaptureGroups(str);
      Object.keys(replacements).forEach(function (match) {
        var replacement = replacements[match];
        var data = args[replacement.name];
        var rule = _this.rules[replacement.rule] || _this.rules.string;
        var search = new RegExp((0, _escapeStringRegexp["default"])(match), 'g');
        str = str.replace(search, rule(data, replacement.name));
      });
      return str;
    }
  }], [{
    key: "findCaptureGroups",
    value: function findCaptureGroups(str) {
      var groups = {};
      var match = REGEX_RULES_EXTRACTOR.exec(str);

      while (match != null) {
        // matched text: match[0]
        // match start: match.index
        // capturing group n: match[n]
        var fullMatch = match[0];
        groups[fullMatch] = {
          name: match[1],
          rule: match[2]
        };
        match = REGEX_RULES_EXTRACTOR.exec(str);
      }

      return groups;
    }
  }]);

  return RulesManager;
}();

exports.RulesManager = RulesManager;